import { Grid, Box, Typography, Button, useTheme, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import Github from "../img/github.png";
import LinkedIn from "../img/linkedin.png";
import Stackover from "../img/stackover.png";
import Vector1 from "../img/Vector1.png";
import Vector2 from "../img/Vector2.png";
import boy from "../img/lakshay1.png";
import glassesimoji from "../img/glassesimoji.png";
import thumbup from "../img/thumbup.png";
import crown from "../img/crown.png";
import FloatingDiv from "./FloatingDiv/FloatingDiv";
import { useContext } from "react";
import { themeContext } from "../context";
import { useNavigate } from 'react-router-dom'; 

export default function IntroSection() {
  const theme = useContext(themeContext);
  const darkMode = theme?.state?.darkMode;
  const transition = { duration: 2, type: "spring" };

  const themeHook = useTheme();
  const isSmallScreen = useMediaQuery(themeHook.breakpoints.down("md"));

  // Experience Calculation in years.month format
  const startDate = new Date(2021, 4); // May 2021 (Month index starts from 0)
  const currentDate = new Date();
  const diffInMonths = (currentDate.getFullYear() - startDate.getFullYear()) * 12 + (currentDate.getMonth() - startDate.getMonth());
  const experience = `${Math.floor(diffInMonths / 12)}.${diffInMonths % 12}`;

  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      sx={{ height: "77vh", mt: 3 }}
    >
      {/* Left Side */}
      <Grid item xs={12} md={6}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography
            variant="h3"
            sx={{ fontWeight: "bolder", fontSize: "60px" }}
            color={darkMode ? "white" : "black"}
          >
            Hey! I Am
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "bolder", fontSize: "60px" }}
            color="orange"
          >
            Lakshay Rohilla
          </Typography>
          <Typography variant="body2" color="gray">
            Web developer and web designer with {experience}+ years of experience
            dedicated to developing and optimizing interactive, user-friendly,
            and feature-rich websites. Leverage analytical skills, data
            structures, and algorithms to build impactful web solutions.
          </Typography>
          <Typography variant="body2" color="gray">
            With a strong foundation in software development and a commitment to
            Agile methodologies, I aim to continue creating impactful
            applications, collaborating with cross-functional teams, and staying
            at the forefront of technological advancements in the software
            development industry.
          </Typography>
          <Button
            sx={{
              mt: 2.2,
              width: "8rem",
              height: "2.5rem",
              color: "white",
              borderRadius: "20px",
              fontWeight: "bold",
            }}
            className="button"
            onClick={() => navigate('/Contact')}
          >
            Hire me
          </Button>
          <Box display="flex" gap={6} mt={3}>
            <a
              href="https://github.com/LakshayRohilla"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Github} alt="Github" width={43} />
            </a>
            <a
              href="https://www.linkedin.com/in/lakshay-rohilla-02a23a119/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={LinkedIn} alt="LinkedIn" width={43} />
            </a>
            <a
              href="https://stackoverflow.com/users/16876542/lakshay-rohilla"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Stackover} alt="StackOverflow" width={43} />
            </a>
          </Box>
        </Box>
      </Grid>

      {/* Right Side */}
      <Grid item xs={12} md={6}>
        <Box
          position="relative"
          sx={{
            height: { xs: "60vh", md: "100%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Background Vectors */}
          <Box
            component="img"
            src={Vector1}
            alt="Vector 1"
            sx={{
              position: "absolute",
              left: { xs: "5%", md: "0%" },
              top: { xs: "25%", md: "10%" },
              width: { xs: "75%", md: "70%" },
              height: { xs: "55%", md: "89%" },
              zIndex: -1,
            }}
          />
          <Box
            component="img"
            src={Vector2}
            alt="Vector 2"
            sx={{
              position: "absolute",
              top: { xs: "25%", md: "16%" },
              left: { xs: "15%", md: "16%" },
              width: { xs: "75%", md: "70%" },
              height: { xs: "55%", md: "89%" },
              zIndex: -1,
            }}
          />
          {/* Main Boy Image */}
          <Box
            component="img"
            src={boy}
            alt="Profile"
            sx={{
              position: "relative",
              width: { xs: "65%", md: "100%" },
              maxWidth: "350px",
              zIndex: 2,
            }}
          />
          {/* Floating Glasses */}
          <motion.img
            initial={{ left: "-50%" }}
            whileInView={{ left: isSmallScreen ? "10%" : "-6%" }}
            transition={transition}
            src={glassesimoji}
            alt="Glasses"
            style={{
              position: "absolute",
              top: isSmallScreen ? "18%" : "0%",
              left: isSmallScreen ? "40%" : "60%",
              width: "15%",
            }}
          />
          ;{/* Floating Crown (Web Developer) */}
          <motion.div
            initial={{ top: "5%", left:isSmallScreen ? "0%" : "70%"}}
            whileInView={{ left: isSmallScreen ? "10%" : "65%" }}
            transition={transition}
            style={{
              position: "absolute",
              // { xs: "-30%", md: "35%" 
              top: isSmallScreen ? "-10%" : "35%",
              left: { xs: "-58%", md: "65%" },
              width: { xs: "100px", md: "120px" },
            }}
          >
            <FloatingDiv image={crown} txt1="Web" txt2="Developer" />
          </motion.div>
          {/* Floating Thumbs Up (Team Player) */}
          <motion.div
            // initial={{ left: "9rem", top: "18rem" }}
            initial={{ left: isSmallScreen ? "1rem" : "9rem", top: isSmallScreen ? "1rem" : "18rem" }}
            whileInView={{ left: "0rem", top: "21rem" }}
            transition={transition}
            style={{
              position: "absolute",
              bottom: { xs: "5%", md: "40%" },
              left: { xs: "20%", md: "10%" },
              width: { xs: "100px", md: "120px" },
            }}
          >
            <FloatingDiv image={thumbup} txt1="Team" txt2="Player!" />
          </motion.div>
          {/* Blur Background Effects */}
          <Box
            sx={{
              position: "absolute",
              width: { xs: "10rem", md: "22rem" },
              height: { xs: "6rem", md: "14rem" },
              borderRadius: "50%",
              background: "rgb(238 210 255)",
              zIndex: -9,
              top: { xs: "-10%", md: "-18%" },
              left: { xs: "40%", md: "56%" },
              filter: "blur(72px)",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              width: { xs: "10rem", md: "21rem" },
              height: { xs: "6rem", md: "11rem" },
              borderRadius: "50%",
              background: "#C1F5FF",
              top: { xs: "50%", md: "17rem" },
              left: { xs: "-5rem", md: "-9rem" },
              filter: "blur(72px)",
              zIndex: -9,
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
